<template>
  <div></div>
</template>
<script>
import {getTeacherIdFromSessionStorage} from "@/util/getTeacherId";
import {getIndexPathFromStorage} from "@/util/getInitRoutePath";

export default {
  name: "wxlogin",
  data() {
    return {
      appid: "wx9bd84c6cafeeefa0",
      code: "",
      state: "qweewq123",
      teacher_id: getTeacherIdFromSessionStorage(),
    };
  },
  mounted() {
    let code = this.$route.query.code;
    // let redirect_url = this.$route.query.redirect_url;
    let openid = this.$ls.get("user_openid_new");
    if (openid) {
      this.$router.back();
      console.log("router back", openid);
      return;
    }
    if (code) {
      this.getopenId(code);
    } else {
      let uri = "https://mall.zhangshangcj.com/wxlogin";
      if (this.teacher_id) {
        uri = uri + "?teacher_id=" + this.teacher_id;
      }
      // let redirect_uri = encodeURIComponent(redirect_url ? redirect_url : uri);
      let redirect_uri = encodeURIComponent(uri);
      let url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.appid +
          "&redirect_uri=" +
          redirect_uri +
          "&response_type=code&scope=snsapi_base&state=" +
          this.state +
          "#wechat_redirect";
      // window.location.href = url;
      window.location.replace(url);
    }
  },
  methods: {
    async getopenId(code) {
      let res = await this.$axios.get("/wx/getWxOpenId", {
        params: {
          code,
          mp_name: "wcsj",
        },
      });
      if (res.code == 10001) {
        let test = {
          code: 10001,
          tip: "#2166",
          msg: "\u5fae\u4fe1\u767b\u5f55\u6210\u529f",
          data: {open_id: "oFZQy02WjqjDKPbSdv-Sp4wWpu74"},
        };
        // this.$toast.success(res.msg);
        this.$ls.set("user_openid_new", res.data.open_id);
        setTimeout(() => {
          this.$router.replace(getIndexPathFromStorage())
        }, 500);
      } else {
        this.$toast.fail(res.msg);
      }
    },
  },
};
</script>
<style></style>
